import CircularProgress from "@material-ui/core/CircularProgress"
import Dialog from "@material-ui/core/Dialog"
import IconButton from "@material-ui/core/IconButton"
import DialogContent from "@material-ui/core/DialogContent"
import { makeStyles } from "@material-ui/core/styles"
import { BillingSettingsForm } from "./index"
import { useLazyGetBillingSettingsQuery } from "../../api"
import { useEffect } from "react"
import { X } from "react-feather"
import { Typography } from "@material-ui/core"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: "100%",
    maxWidth: 600,
  },
  dialogHeader: {
    padding: theme.spacing(2, 3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 200,
  },
}))

type BillingSettingsFormDialogProps = {
  orgId: string
  open: boolean
  onClose: () => void
}

export function BillingSettingsFormDialog({ orgId, open, onClose }: BillingSettingsFormDialogProps) {
  const [getBillingSettingsQuery, queryResult] = useLazyGetBillingSettingsQuery()
  const classes = useStyles()
  const { data: billingSettings, isLoading } = queryResult
  const { t } = useTranslation("membership")

  useEffect(() => {
    if (open) getBillingSettingsQuery(orgId)
  }, [orgId, open, getBillingSettingsQuery])

  const policyAgreedAt = billingSettings?.policyAgreedAt || null
  const policyAgreedBy = billingSettings?.policyAgreedBy || null

  return (
    <>
      <Dialog open={open} onClose={() => onClose()} classes={{ paper: classes.dialogPaper }} scroll="paper">
        <div className={classes.dialogHeader}>
          <Typography variant="h5">{t("fillBillingInfo")}</Typography>
          <IconButton color="inherit" size="small" edge="end" onClick={() => onClose()}>
            <X />
          </IconButton>
        </div>
        <DialogContent dividers style={{ padding: 0 }}>
          {isLoading || !billingSettings ? (
            <div className={classes.spinnerContainer}>
              <CircularProgress />
            </div>
          ) : (
            <BillingSettingsForm
              policyAgreedAt={policyAgreedAt}
              policyAgreedBy={policyAgreedBy}
              orgId={orgId}
              billingSettings={billingSettings}
              onAfterSave={onClose}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
